import BaseListPresenter from "../../base/BaseListPresenter";
import { buildDateQuery } from "./utils/utils";

class DashboardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
    getObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      upsertUseCase,
      getCurrentUserUseCase,
      getObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.getObjectUseCase = getObjectUseCase;
  }

  componentDidMount() {
    this.init();
    this.createQuery();
    this.findObjects();
    this.getBankAccounts();
    this.countObjects();
  }

  init() {
    const { category, year, years, month, quarter, half } = this.view.state;
    const dateFilter = buildDateQuery({
      type: category,
      years: years,
      year: year,
      month: month,
      quarter: quarter,
      half: half,
    });

    const gte = dateFilter.date.gte;
    const lte = dateFilter.date.lte;
    // this.limit = 9999;

    const user = this.view.getCurrentUser();

    this.where = {
      date: {
        $gte: gte,
        $lte: lte,
      },
      $or: [{ creator: { id: user.id } }, { client: { id: user.client?.id } }],
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    const purchaseCollection = "purchases";
    const salesCollection = "sales";
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const [purchases, sales] = await Promise.all([
        this.findObjectUseCase.execute(purchaseCollection, query),
        this.findObjectUseCase.execute(salesCollection, query),
      ]);

      this.view.setState({ receipts: purchases, sales: sales });

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async runWithProgress(callback) {
    try {
      this.showProgress();
      await callback();
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.hideProgress();
    }
  }

  async getBankAccounts() {
    const collection = "banks";
    const user = this.view.getCurrentUser();
    try {
      this.showProgress();
      // this.view.showBanksLoading();

      const banks = await this.findObjectUseCase.execute(collection, {
        where: {
          $or: [
            { creator: { id: user.id } },
            { client: { id: user.client?.id } },
          ],
        },
      });

      this.view.setState((prevState) => ({ ...prevState, banks: banks }));
      // this.view.hideBanksLoading();
      this.hideProgress();
    } catch (error) {
      console.error(error);
      // this.view.hideBanksLoading();
      this.hideProgress();
      this.view.showError(error);
    }
  }
}

export default DashboardPresenter;
